var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSriLanka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0341C24.8365 32.0341 31.9999 24.8707 31.9999 16.0341C31.9999 7.19761 24.8365 0.0341797 16 0.0341797C7.16343 0.0341797 0 7.19761 0 16.0341C0 24.8707 7.16343 32.0341 16 32.0341Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5218 2.81638H6.98213C6.73663 2.98419 6.49638 3.15888 6.26094 3.33969L4.86963 16.0337L6.26094 28.7277C6.49638 28.9086 6.73663 29.0833 6.98213 29.2511H12.5218V2.81638Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0338C0 21.2054 2.45426 25.803 6.26089 28.7278V3.33973C2.45426 6.26461 0 10.8622 0 16.0338V16.0338Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.739 9.78777V10.1881L25.7539 10.1903L25.739 9.78777Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7246 20.2077H27.71L26.4347 21.599V24.3816H23.6521V22.9903H25.0434V20.2077H18.7825V21.9468H17.3912V18.6323C16.9643 18.2502 16.6956 17.6952 16.6956 17.0772V8.03376C16.6956 6.8812 17.63 5.94682 18.7825 5.94682V18.8164H21.5652L22.5199 18.0207C22.3532 17.6235 22.2608 17.1873 22.2608 16.7295V14.6425H20.1738V10.4686H24.3477C24.3477 9.77301 25.3912 9.07733 25.3912 9.07733C25.3912 9.07733 26.4347 9.77295 26.4347 10.4686V11.5121V14.6426C27.2087 14.6518 28.4383 14.6317 29.7667 14.6426C29.4177 14.0326 29.2173 13.3088 29.2173 12.5556C29.2173 11.3281 29.7473 10.2245 30.5909 9.4607C29.3749 6.76601 27.4345 4.46838 25.0178 2.81638H14.6086V29.2512H25.0179C27.9566 27.2424 30.1909 24.2792 31.2749 20.808L30.7246 20.2077Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSriLanka);
export default __webpack_public_path__ + "static/media/sri-lanka.deb06def.svg";
export { ForwardRef as ReactComponent };